import { createFileRoute } from '@tanstack/react-router'
import NotFoundMessage from 'components/basic/not-found-message'

export const Route = createFileRoute('/site/terms')({
   head: () => ({
      meta: [{ title: 'Terms of Use' }, { name: 'robots', content: 'noindex' }],
   }),
   component: () => <NotFoundMessage>Terms of Use content not available.</NotFoundMessage>,
})
